module.exports = __webpack_public_path__ + "static_pc/img/marquee2.399ab89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/marquee2.jpg
// module id = fIrK
// module chunks = 1